import { render, staticRenderFns } from "./loadeUnloadeOrderEdit.vue?vue&type=template&id=64395867&scoped=true&"
import script from "./loadeUnloadeOrderEdit.vue?vue&type=script&lang=js&"
export * from "./loadeUnloadeOrderEdit.vue?vue&type=script&lang=js&"
import style0 from "./loadeUnloadeOrderEdit.vue?vue&type=style&index=0&id=64395867&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64395867",
  null
  
)

export default component.exports